import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-panel py-16 sm:py-24" data-id="element-323" data-mp="3mfhi6a4gs5kd">
      <div className="mx-auto max-w-6xl px-4" data-id="element-324" data-mp="3r7sfr6bqff9r">
        <SectionHeading kicker="Real technicians. Real workshops." title={<>What mechanics say about <span className="text-brand" data-id="element-326" data-mp="3k7g1z9elqu">the blueprint</span></>} data-id="element-325" data-mp="3r9lnyq1zu7jv" />

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-327" data-mp="418a5r771ita">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-line bg-ink p-5 sm:p-7" data-id="element-328" data-mp="92fipsh5um10">
              <div className="flex items-center gap-4" data-id="element-329" data-mp="e07g320kr0cl">
                <img src={t.photo} alt={t.name} className="h-20 w-20 shrink-0 rounded-2xl object-cover sm:h-24 sm:w-24" data-id="element-330" data-mp="2au2cg1sfsv16" />
                <div className="min-w-0" data-id="element-331" data-mp="2fsvpjt3tak0t">
                  <p className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-332" data-mp="1skj4id9mv1lh">{t.name}</p>
                  <p className="text-sm font-semibold text-brand" data-id="element-333" data-mp="1ntatxdwkha6q">{t.role}</p>
                  <p className="mt-0.5 flex items-center gap-1 text-sm text-muted" data-id="element-334" data-mp="1iuprd7tueef4">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-335" data-mp="1isn6113mx9gq" />
                    {t.country}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-336" data-mp="2bi3pvad6vi1c">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-brand text-brand" aria-hidden="true" data-id="element-337" data-mp="22ip3am057rm4" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 flex-1 text-lg leading-relaxed text-white" data-id="element-338" data-mp="1xkfauj5sz547">“{t.quote}”</blockquote>
            </figure>)}
        </div>

        <CtaButton className="mt-12" label="Join These Technicians Today" data-id="element-339" data-mp="r179ae8d66cs" />
      </div>
    </section>;
}